import {registerPlugin} from '@capacitor/core'

export interface IReadFileChunk {
  data: string | Blob
}

// values match @capacitor/filesystem's Directory enum
export enum FilesystemDirectoryType {
  Cache = 'CACHE',
  Documents = 'DOCUMENTS',
}

interface IFilesystemPlugin {
  readFileInChunks(
    options: {path: string, chunkSize: number},
    callback: (chunk: IReadFileChunk | null, error?: unknown) => void,
  ): Promise<string>
  getUri(options: {path: string, directory: FilesystemDirectoryType}): Promise<{uri: string}>
  stat(options: {path: string}): Promise<{type: string, size: number, mtime: number, uri: string}>
  mkdir(options: {path: string, directory: FilesystemDirectoryType, recursive?: boolean}): Promise<void>
  rmdir(options: {path: string, directory: FilesystemDirectoryType, recursive?: boolean}): Promise<void>
}

export const FilesystemPlugin = registerPlugin<IFilesystemPlugin>('Filesystem')
